import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

export const PdpQuantityRules = ({ maxQuantity }) => {
  if (!maxQuantity) return null;

  return (
    <div className='mt8-sm'>
      <div className='body-2 u-bold'>
        <TranslatedCopy id='pdp.quantityRules.title' />
      </div>

      <div className='text-color-secondary body-3'>
        <TranslatedCopy id='pdp.quantityRules.max' values={{ amount: maxQuantity }} />
        <br />
      </div>
    </div>
  );
};

PdpQuantityRules.propTypes = {
  maxQuantity: PropTypes.number
};

PdpQuantityRules.defaultProps = {
  maxQuantity: null
};

export default PdpQuantityRules;
